/** Which bootstrap shell loaded (main App vs lean FoodApp). Set once in main.tsx. */
export type AppShell = "main" | "food";

let shell: AppShell = "main";

export function setAppShell(next: AppShell): void {
  shell = next;
}

export function getAppShell(): AppShell {
  return shell;
}

/** Leave food/checkout lean shell → full super-app home at /. */
export function navigateAppHome(spaNavigate: (path: string) => void): void {
  if (getAppShell() === "food") {
    window.location.assign("/");
    return;
  }
  spaNavigate("/");
}
